<template>
    <div>
        <navbar/>
             <div class="container-fluid">
            <h2>Crear Contacto</h2>
            <button @click="agregar">Add</button>
            <div class="row">
                <div class="col-md-6 ">
                    Identificador: 
                    <input class="form-control" v-model="form.identificador">
                </div>
                <div class="col-md-6 ">
                    Nombre: 
                    <input class="form-control" v-model="form.nombre">
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 ">
                     Apellido: 
                    <input class="form-control" v-model="form.apellido">
                </div>
                <div class="col-md-6 ">
                    Correo: 
                    <input  class="form-control" v-model="form.email">
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                    
                    Grupos:
                    <select class="form-control" v-model="form.gruposkills">
                        <option v-for="item in allGrupos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
                <div class="col-md-6 ">
                    Dirección:
                    <input class="form-control" v-model="form.direccion">
                </div>
            </div>

            <div class="row">
                <div class="col-md-6 ">
                    Cargo:
                    <input class="form-control" v-model="form.cargo">
                </div>
                <div class="col-md-6 ">
                   
                    Acuerdo:
                    <select class="form-control" v-model="form.idsla">
                        <option v-for="item in allAcuerdos" :key="item.id" :value="item.id">{{item.nombre}}</option>
                    </select>
                </div>
            </div>

            <h3>Redes Sociales</h3>
            <div class="row">
                <div class="col-md-4">
                    Facebook:
                    <input class="form-control" v-model="form.facebook">
                </div>
                <div class="col-md-4">
                    Twitter:
                    <input class="form-control" v-model="form.twitter">
                </div>
                <div class="col-md-4">
                    Instagram:
                    <input class="form-control" v-model="form.instagram">
                </div>
            </div>
           
            <pre>{{form}}</pre>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    components: {
        navbar: () => import('@/views/Agente/navBar.vue')
    },
    data(){
        return{
            form:{
                cf: {},
                origin: window.location.hostname
            }
        }
    },
    computed: {
        ...mapGetters('validatetoken', { 
            oneContacto: 'oneContacto',
            allAcuerdos: 'allAcuerdos',
            allGrupos: 'allGrupos'
        })
    },
      methods:{
        ...mapActions('validatetoken', {
            getAllAcuerdo: 'getAllAcuerdo',
            getByGruposSkill: 'getByGruposSkill',
            addContacto: 'addContacto'
            //proceso
        }),
        getAll(){
            Promise.all([
                this.getAllAcuerdo(),
                this.getByGruposSkill({
                    tipo: 2
                })
            ])
        },
        agregar(){
            if (this.form.email || form.gruposkills){
                this.form.email = [this.form.email]
                this.form.gruposkills = [this.form.gruposkills]
            }
           
             this.addContacto(this.form)
        },
   
    },
    created() {
        this.getAll()
    },
}
</script>